import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SelectImageAddPage } from './select-image-add';

@NgModule({
  declarations: [
    SelectImageAddPage,
  ],
  imports: [
    IonicPageModule.forChild(SelectImageAddPage),
    HttpClientModule
  ],
})
export class SelectImageAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/select-image-add/select-image-add.module.ts